import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useRouter } from "next/router";
import { AppState } from "../../../../app/store/store";
import AnalyticsFrom from "../../../Features/analytics/analytics-form/analytics-form";
import classes from "./AnalyticsFormScreen.module.scss";

const AnalyticsFormScreen = () => {
    const router = useRouter();
    const storeName = "analyticsForm";
    const selectedBrand = useSelector((state: AppState) => state[storeName].selectedBrand);
    const selectedModel = useSelector((state: AppState) => state[storeName].selectedModel);
    const selectedGeneration = useSelector(
        (state: AppState) => state[storeName].selectedGeneration
    );
    const driveType = useSelector((state: AppState) => state[storeName].selectedDrive);
    const bodyType = useSelector((state: AppState) => state[storeName].selectedBodyType);
    const engineType = useSelector((state: AppState) => state[storeName].selectedEngine);
    const transmission = useSelector((state: AppState) => state[storeName].selectedTransmission);
    const engineDisplacement = useSelector(
        (state: AppState) => state[storeName].selectedEngineDisplacement
    );
    const year = useSelector((state: AppState) => state[storeName].selectedYear);
    const generation = useSelector((state: AppState) => state[storeName].selectedGeneration);
    const pts = useSelector((state: AppState) => state.analyticsForm.selectedPts);
    const mileage = useSelector((state: AppState) => state[storeName].selectedMileage);
    const ownerQnt = useSelector((state: AppState) => state[storeName].ownerQnt);

    const [isValid, setIsValid] = React.useState(false);

    useEffect(() => {
        setIsValid(
            !!selectedBrand &&
                !!selectedModel &&
                !!driveType &&
                !!bodyType &&
                !!engineType &&
                !!transmission &&
                !!engineDisplacement &&
                !!year &&
                !!generation &&
                !!pts &&
                !!mileage &&
                !!ownerQnt
        );
    }, [
        selectedBrand,
        selectedModel,
        driveType,
        bodyType,
        engineType,
        transmission,
        engineDisplacement,
        year,
        generation,
        pts,
        mileage,
        ownerQnt
    ]);

    const generateQueryString = () => {
        let queryString = [];

        if (selectedBrand) {
            queryString.push(`brandUuid=${selectedBrand?.id}`);
        }

        if (selectedModel) {
            queryString.push(`modelUuid=${selectedModel?.id}`);
        }

        if (selectedGeneration) {
            queryString.push(`generationUuid=${selectedGeneration?.id}`);
        }

        if (driveType) {
            queryString.push(`driveType=${driveType}`);
        }

        if (bodyType) {
            queryString.push(`bodyType=${bodyType}`);
        }

        if (engineType) {
            queryString.push(`engineType=${engineType}`);
        }

        if (transmission) {
            queryString.push(`transmission=${transmission}`);
        }

        if (engineDisplacement) {
            queryString.push(`engineDisplacement=${engineDisplacement}`);
        }

        if (pts) {
            queryString.push(`pts=${pts}`);
        }

        if (mileage) {
            queryString.push(`mileage=${mileage}`);
        }

        if (ownerQnt) {
            queryString.push(`ownerQnt=${ownerQnt}`);
        }

        return queryString.join("&");
    };

    return (
        <div className={classes.AnalyticsFormScreen}>
            <h1>Оценка стоимости автомобиля</h1>

            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    flexWrap: "wrap"
                }}
            >
                <AnalyticsFrom
                    isValidationsVisible={true}
                    isEditing={false}
                    showPropsChanged={() => {}}
                    onBlockFilled={() => {}}
                />

                <button
                    onClick={() => {
                        if (isValid) {
                            router.push("/analytics/estimation" + "?" + generateQueryString());
                        } else {
                            toast.warn(`Указаны не все параметры`, {});
                        }
                    }}
                    className={`${classes.EstimateButton} ${!isValid ? classes.Disabled : ""}`}
                >
                    Оценить автомобиль
                </button>
            </div>
        </div>
    );
};
export default AnalyticsFormScreen;